// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { getTranslate } from 'react-localize-redux';
import { setCurrentScope } from 'actions/user/user';
import RoutesURL from 'routes/routes';
import './navigation.css';

class Navigation extends Component {

  overrideNavigationTitle = '';

  state = {
    pageTitle: '',
    scopeSelectActive: false
  }

  _inputOpener = null;

  constructor(props) {
    super(props);
    this._handleOpener = this._handleOpener.bind(this);
    this._handleHolderOutside = this._handleHolderOutside.bind(this);
    this._renderOption = this._renderOption.bind(this);
    this._changeScope = this._changeScope.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this._handleHolderOutside);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.navTitle) {
      this.overrideNavigationTitle = nextProps.navTitle;
    }
  }

  _changeScope = (e) => {
    const { dispatch } = this.props;
    dispatch(setCurrentScope(e)).then(() => {
      window.location.reload();
    });
  }

  _getScope() {
    const { scopes, scope_id } = this.props.user;
    if (!scopes || !scope_id) { return null };
    const currentScope = scopes.find((item) => {
      return item.id === scope_id;
    });
    this._setBusinessClassToBody(currentScope.type);
    return currentScope.type;
  }

  _setBusinessClassToBody = (businessClass: string = '') => {
    let bodyTag = document.querySelector('body');
    if (!bodyTag) return false;
    bodyTag.classList.add(businessClass);
  }

  _toggleSelect = () => {
    this.setState({ scopeSelectActive: !this.state.scopeSelectActive });
  }

  _renderOptions = () => {
    const { scopes, scope_id } = this.props.user;
    if (!this.state.scopeSelectActive) { return null };
    const noActiveScopes = scopes.filter((item) => {
      return item.id !== scope_id;
    });
    return (
      <div>{noActiveScopes.map(this._renderOption)}</div>
    )
  }

  _renderOption = (item) => {
    const { translate } = this.props;
    return (
      <li className={`tab-static-height scope-${item.type}`} key={item.id} onClick={() => { this._changeScope(item.id) }}>
        <a>
          {translate(`navigation.${item.type}`)}
        </a>
      </li>
    )
  }

  _renderScopeTab() {
    const { scopes } = this.props.user;
    const { translate } = this.props;
    const currentScope = String(this._getScope());

    if (!scopes || scopes.length < 2) {
      return (
        <li className='tab-static-height empty' />
      )
    } else {
      let iconClass = this.state.scopeSelectActive ? 'glyphicon-triangle-top' : 'glyphicon-triangle-bottom'
      return (
        <li className={`tab-static-height scope-${currentScope} white-non-hover`} onClick={this._toggleSelect}>
          <a className="switcher">
            <i className="ico ico-8"></i>
            {translate(`navigation.${currentScope}`)}
          </a>
          <div className="scope-ico">
            <i className={`glyphicon ${iconClass}`}></i>
          </div>
        </li>
      )
    }
  }

  render() {
    const { translate, user, navTitle } = this.props;
    const { pageTitle } = this.state;
    let navigationTitle = pageTitle;

    if (pageTitle === '' && navTitle && navTitle.title !== '') {
      navigationTitle = navTitle.title;
    }

    const scope = String(this._getScope());
    const terms_and_conditions_link = scope === 'business' ? process.env.REACT_APP_TERMS_AND_CONDITIONS_B2B : process.env.REACT_APP_TERMS_AND_CONDITIONS;

    return (
      <aside className="navigation">
        <nav className="nav-bar">
          <div className="holder" onMouseEnter={this._handleHolderEnter} onMouseLeave={this._handleHolderLeave}>
            <strong className="logo"><Link to='/'>{translate('common.site_title')}</Link></strong>
            <ul id="main-nav">
              {this._renderScopeTab()}
              {this._renderOptions()}
              <li className={this._isLinkSelected(RoutesURL.main())}><Link to={RoutesURL.main()}><i className={`ico ico-1 ${scope}`}></i>{translate('navigation.insurance_inquiry')}</Link></li>
              <li className={this._isLinkSelected(RoutesURL.special_deals())}><Link to={RoutesURL.special_deals()}><i className={`ico ico-4 ${scope}`}></i>{translate('navigation.special_deals')}</Link></li>
              <li className={this._isLinkSelected(RoutesURL.settings())}><Link to={RoutesURL.settings()}><i className={`ico ico-5 ${scope}`}></i>{translate('navigation.settings')}</Link></li>
              <li className={this._isLinkSelected(RoutesURL.help())}><Link to={RoutesURL.help()}><i className={`ico ico-6 ${scope}`}></i>{translate('navigation.help')}</Link></li>
              <li>
                <a href={terms_and_conditions_link} target="_blank">
                  <i className="fa fa-file-text-o ico-menu" />
                  {translate('navigation.terms')}
                </a>
              </li>
              <li>
                <a href={process.env.REACT_APP_PERSONAL_POLITIC} target="_blank">
                  <i className="fa fa-lock ico-menu" />
                  {translate('navigation.politics')}
                </a>
              </li>
              <li><Link to={{ pathname: RoutesURL.logout(), state: { email: user.email, id: user.id } }}><i className={`ico ico-7 ${scope}`}></i>{translate('navigation.logout')}</Link></li>
            </ul>
          </div>
          <strong className="selected-topic">{navigationTitle}</strong>
          <span className="opener" onClick={this._handleOpener} ref={(ref) => this._inputOpener = ref}></span>
        </nav>
      </aside>
    );
  }

  _setPageTitle = (override: string = '') => {
    let activeLink = document.querySelectorAll('#main-nav li.active');
    if (!activeLink.length) {
      // Try to find title from document title
      if (override !== '') {
        this.setState({ pageTitle: override });
      }
    } else {
      let title = activeLink[0].innerText || false;
      if (title === false) return false;
      title = title.trim();
      this.setState({ pageTitle: title });
    }
  }

  _isLinkSelected = (url: string = '/') => {
    const { location } = this.props;
    if (url === '/' && location.pathname !== '/') return '';
    return (location.pathname.match(url + '*') !== null ? `active ${String(this._getScope())}` : '');
  }

  // When user click on arrow
  _handleOpener = (e: any) => {
    let htmlTag = e.target.closest('html');
    if (!htmlTag.classList.contains('push')) {
      htmlTag.classList.add('push');
      htmlTag.classList.add('opening');
    } else {
      htmlTag.classList.remove('push');
      setTimeout(function () {
        htmlTag.classList.remove('opening');
      }, 500);
    }
    e.preventDefault();
  }

  // When user move over the left menu with mouse pointer
  _handleHolderEnter = (e: any) => {
    let htmlTag = e.target.closest('html');
    if (!htmlTag.classList.contains('push-hover')) {
      if (window.innerWidth > 640) {
        htmlTag.classList.add('push-hover');
      }
      htmlTag.classList.add('opening-hover');
    }
  }

  // When left menu loses it's focus from mouse pointer
  _handleHolderLeave = (e: any) => {
    let htmlTag = e.target.closest('html');
    htmlTag.classList.remove('push-hover');
    this.setState({ scopeSelectActive: false });
    setTimeout(function () {
      htmlTag.classList.remove('opening-hover');
    }, 500);
    e.preventDefault();
  }

  // When you click outside the navigation, close it
  _handleHolderOutside = (e: any) => {
    const { target } = e;
    let container = document.getElementsByClassName('nav-bar');
    if (!container || !container.length) return false;
    container = container[0];
    if (container.contains(target) === false) {
      let htmlTag = target.closest('html');
      htmlTag.classList.remove('push');
      setTimeout(function () {
        htmlTag.classList.remove('opening');
      }, 500);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    translate: getTranslate(state.locale),
    navTitle: state.navigation
  }
}

export default withRouter(connect(mapStateToProps)(Navigation));



// WEBPACK FOOTER //
// ./src/components/common/navigation/navigation.js